import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment-timezone';

class RaceClock extends React.Component {

  static getOffset(num) {

    // console.log('Getting Offset for: ' + num);

    var off = -48;
    if (num == 0) return 9 * off;
    else if (num == 1) return 0;
    return (num - 1) * off;

  }

  constructor(props) {
    super(props);

    this.state = {
      showClock: false,
      startEpoch: null,
      endEpoch: null,
      pos1: -48,
      pos2: 0,
      pos3: 0,
      pos4: 0,
      pos5: 0,
      pos6: 0,
      setClockFinish: false
    };
    this.isDST = false;
    this.calcOffset = 0;
  }

  clockUpdateInterval = null;

  componentWillMount(){
    let showClock = false;
    if(this.props.raceDetail && this.props.raceDetail.clock_start && this.props.raceDetail.clock_start !== '00:00:00') {

      try {
        showClock = true;

        const d = new Date();
        const tzOffset = parseInt(this.props.raceDetail.timezone);

        const dateParts = this.props.raceDetail.event_date.split('-').map(x => parseInt(x));
        const timeParts = this.props.raceDetail.clock_start.split(':').map(x => parseInt(x));
        this.isDST = moment.tz(this.props.raceDetail.event_date, "America/Los_Angeles").isDST();
        this.calcOffset = new Date().getTimezoneOffset() * 60 * 1000 - tzOffset * 1000 * 60 * 60;

        // const startEpoch = new Date(dateParts[0], dateParts[1] -1, dateParts[2], timeParts[0] + tzOffset, timeParts[1], timeParts[2]).getTime();
        //const startEpoch = new Date(`${this.props.raceDetail.event_date} ${this.props.raceDetail.clock_start}0${tzOffset * 100}`).getTime();

        let startEpoch = new Date(dateParts[0], dateParts[1] -1, dateParts[2], timeParts[0], timeParts[1], timeParts[2]).getTime() - this.calcOffset;
        startEpoch -= this.isDST ? 60*60*1000 : 0;
        const endEpoch = startEpoch + parseInt(this.props.raceDetail.clock_max) * 1000;

        console.log({raceDetail: this.props.raceDetail, dateParts, timeParts, startEpoch, endEpoch});

        this.setState({showClock, startEpoch, endEpoch});

      }catch(err) {
        // console.log('Got error while trying to show race clock: ' + err);
      }
    }

    if (this.state.showClock !== showClock){
      this.setState({showClock});
    }
  }

  componentDidMount() {
    const _this = this;
    this.clockUpdateInterval = setInterval(() => {
      _this.updateClock();
    }, 200);
  }

  // componentWillUpdate(newProps){
  //   console.log('got here');
  //   let showClock = false;
  //   if(newProps.raceDetail && newProps.raceDetail.clock_start && newProps.raceDetail.clock_start !== '00:00:00') {
  //     showClock = true;
  //   }
  //
  //   if (this.state.showClock !== showClock) {
  //     this.setState({showClock});
  //   }
  // }

  updateClock(){
    let now = new Date().getTime() - this.calcOffset;
    now -= this.isDST ? 60*60*1000 : 0;
    // console.log(now);
    if (this.state.showClock && this.state.startEpoch && this.state.endEpoch) {

      // console.log({now, start: this.state.startEpoch, end: this.state.endEpoch});

      if (now >= this.state.startEpoch && now <= this.state.endEpoch) {

        const diff = now - this.state.startEpoch;

        // console.log(diff);

        this.setState({
          pos6: RaceClock.getOffset(parseInt(diff / 1000) % 10),
          pos5: RaceClock.getOffset(parseInt(diff / 10000) % 6),
          pos4: RaceClock.getOffset(parseInt(diff / 60000) % 10),
          pos3: RaceClock.getOffset(parseInt(diff / 600000) % 6),
          pos2: RaceClock.getOffset(parseInt(diff / (60000 * 60)) % 10),
          pos1: RaceClock.getOffset(parseInt(diff / (600000 * 60)) % 6),
          setClockFinish: false
        });

      } else {

        if (!this.state.setClockFinish) {
          this.setState({
            pos6: RaceClock.getOffset(this.props.raceDetail.clock_finish.substring(5)),
            pos5: RaceClock.getOffset(this.props.raceDetail.clock_finish.substring(4, 5)),
            pos4: RaceClock.getOffset(this.props.raceDetail.clock_finish.substring(3, 4)),
            pos3: RaceClock.getOffset(this.props.raceDetail.clock_finish.substring(2, 3)),
            pos2: RaceClock.getOffset(this.props.raceDetail.clock_finish.substring(1, 2)),
            pos1: RaceClock.getOffset(this.props.raceDetail.clock_finish.substring(0, 1)),
            setClockFinish: true
          });
        }

      }

    }

  }

  componentWillUnmount() {
    if (this.clockUpdateInterval) {
      clearInterval(this.clockUpdateInterval);
    }
  }

  render() {

    if (this.state.showClock) {

      return (
        <div id="RaceClock">
          <span id="position_1" style={{backgroundPosition: `0 ${this.state.pos1}px`}} />
          <span id="position_2" style={{backgroundPosition: `0 ${this.state.pos2}px`}} />
          <span id="colon_1"/>
          <span id="position_3" style={{backgroundPosition: `0 ${this.state.pos3}px`}} />
          <span id="position_4" style={{backgroundPosition: `0 ${this.state.pos4}px`}} />
          <span id="colon_2"/>
          <span id="position_5" style={{backgroundPosition: `0 ${this.state.pos5}px`}} />
          <span id="position_6" style={{backgroundPosition: `0 ${this.state.pos6}px`}} />
        </div>
      );
    }

    return null;
  };

}


function mapStateToProps(state) {
  return {
    raceDetail: state.rr360.raceDetail
  };
}


export default connect(mapStateToProps, undefined)(RaceClock);



// WEBPACK FOOTER //
// ./src/components/RaceClock.js